module.exports = __webpack_public_path__ + "static/img/background.f542d5f4.svg";